/// <summary>
/// This object provides js functions for current and archive meter readings <br/>
/// <br/>
/// Author: MKU<br />
/// Date: 29.9.2023<br />
/// Copyright ©: EUDT GmbH 2021 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 29.9.2023                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>

jQuery.widget("bluaul.CurrentMeterReadings", $.bluaul.vcMenuTemplate, {

    myStructure: {
        current: {
            obj: null, menu: null,
            list: { header: null, entries: null },
            data: null
        },
        startDate: null,
        endDate: null,
        isSingle: true,
        contentHeight: null,
        allSelectedBsaids: null
    },

    // widget for current meter readings
    _create: function () {
        var me = this;
        try {
            me.element.html("");
            me.options.invoke.vcvid = 353;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
            me._super();

        } catch (e) { me.writeError('_create', e); return false; }
        return true;
    },


    _initVariables: function () {
        var me = this;
        try {

            me._super();
            me.settings.defaultChart = "meterreadings";
            me.settings.menu.top.showMenuAsDropdown = false;
            me.settings.menu.top.interval.intervals = [1];
            me.settings.menu.top.interval.default = 1; //we start with months
            me.settings.signalSelection = true;
            me.settings.showAllSignalsAtStart = true;
            me.settings.enableFilterForInvalidSignals = true;
            me.settings.hideSignalsWithNotAllowedSettings = true;
            me.settings.showArchiveRules = false;
            me.settings.enableMeta = false;

            me.settings.menu.top.showHeaders = true;
            me.settings.menu.top.interval.enabled = false;
            me.settings.menu.top.datatype.enabled = false;
            me.settings.menu.top.charts.enabled = false;
            me.settings.menu.top.opt.enabled = false;
            me.settings.menu.top.opt.showInterventions = false;
            me.settings.menu.top.opt.showTickets = false;

            me.settings.menu.main.button.enabled = true;
            me.settings.menu.main.button.showTakeBtnOnly = false;
            me.settings.menu.main.date.enabled = true;
            me.settings.menu.main.dateComparison.enabled = false;
            me.settings.menu.main.rampResolution.enabled = false;
            me.settings.menu.main.rampOptions.enabled = false;
            me.settings.menu.main.rampTempCharts.enabled = false;
            me.settings.menu.main.specificOptions.enabled = false;
            me.settings.menu.main.history.enabled = false;

            me.settings.menu.top.opt.showTags = false;
            me.settings.menu.top.opt.showRules = false;
            me.settings.menu.top.export.enabled = true;
            me.settings.menu.top.export.showFavorites = false;
            me.settings.menu.top.export.showShare = false;
            me.settings.selection.choice.enabled = true;
            me.settings.selection.entries.button.enabled = false;
            me.settings.selection.entries.signals.showIcons = true;

            me.settings.subvisual.content.signalSelection = false;


        } catch (e) {
            me.writeError('_initVariables', e);
            return false;
        }
        return true;
    },


    _addAdditionalChartsToSettings: function () {
        var me = this;
        try {

            me._super();

            $.each(me.settings.charts, function () { this.enabled = false });
            me.settings.charts.filter(function (item) { return item.id == "meterreadings" })[0].enabled = true;
            me.settings.charts.filter(function (item) { return item.id == "meterreadings" })[0].multiSelect = "multi";

            $.each(me.settings.iconCharts, function () { this.enabled = false });
            me.settings.iconCharts.filter(function (item) { return item.id == "ZSTINFO" })[0].enabled = true;

        } catch (e) {
            me.writeError('_addAdditionalChartsToSettings', e);
            return false;
        }
        return true;
    },

    _loadSubvisualContent: function (contentStatus) {
        /// <summary>
        /// This function loads the chart
        /// </summary>
        var me = this;
        try {

            if (!me.error) {

                me._initSubvisualContent(contentStatus);

                me.myStructure.allSelectedBsaids = contentStatus.signals.selectedBsaids;
                me.myStructure.startDate = contentStatus.menu.startDate;
                me.myStructure.isSingle = contentStatus.date.isSingle;
                if (!contentStatus.date.isSingle)
                    me.myStructure.endDate = contentStatus.menu.endDate;
                else
                    me.myStructure.endDate = null;

                me.myStructure.contentHeight = contentStatus.subvisual.content.height;


                me.vcMenu.subvisual.content.append(me._buildHtml());

                me._updateCurrList();

                // set heights of different divs
                me._setElementHeights();

            }

        } catch (e) { me._writeErr(e); }
    },

    _setElementHeights: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {
            //set height of list
            var parentHeight = me.fnd("#div-current").height();
            var headerHeight = me.fnd("#div-current-header").height();
            var listHeight = parentHeight - headerHeight;
            me.fnd(".lst-entries").css("height", listHeight);


        } catch (e) { me._writeErr(e); }
    },

    _buildHtml: function () {
        var me = this;
        try {
            let obj = null;

            me.myStructure.current = $("<div>").attr("id", "div-current").addClass("mr-current data-container yform").css("height", me.myStructure.contentHeight);
            obj = me.myStructure.current;

            // header of list / columns
            obj.list = $("<div>").attr("id", "div-current-list").addClass("vc-list").css("max-height", me.myStructure.contentHeight);
            obj.header = $("<div>").attr("id", "div-current-header").addClass("vc-list-header color-bg-secondary");
            obj.list.append(obj.header);

            var prevDate = moment(me.myStructure.startDate, "DD.MM.YYYY").subtract(1, 'days').format("DD.MM.YYYY");

            // list with data
            var l = $("<div>").addClass("vc-list-item");
            var c = $("<div>").addClass("vc-list-col");
            l.append(c);
            c.append($("<div>").attr("id", "divCol0").addClass("vc-list-col-element lh col0").html(me.specific.resources.signal));
            c.append($("<div>").addClass("vc-list-col-element lh col1 txtright").html(me.specific.resources.lastMeterReading + " (" + prevDate + ")"));
            c.append($("<div>").attr("id", "divCol2").addClass("vc-list-col-element lh col2").html("<br>"));
            c.append($("<div>").addClass("vc-list-col-element lh col3 txtright").html(me.specific.resources.lastMeterReading + " (" + me.myStructure.startDate + ")"));
            c.append($("<div>").addClass("vc-list-col-element lh col4").html("<br>"));
            c.append($("<div>").addClass("vc-list-col-element lh col5 txtright").html(me.specific.resources.difference));
            c.append($("<div>").addClass("vc-list-col-element lh col6").html("<br>"));
            c.append($("<div>").attr("id", "divCol7").addClass("vc-list-col-element lh col7 centertxt").html(me.specific.resources.type));
            c.append($("<div>").attr("id", "divCol8").addClass("vc-list-col-element lh col8 centertxt").html("Status"));
            c.append($("<div>").attr("id", "divCol9").addClass("vc-list-col-element lh col9"));
            obj.header.append(l);            

            obj.data = $("<div>").addClass("lst-entries vc-list-table ");
            obj.list.append(obj.data);

            obj.append(obj.list);
            return obj;

        } catch (e) {
            me.writeError('_buildHtml', e);
            return false;
        }
        return true;
    },

    _updateCurrList: function () {
        /// <summary>
        /// This function gets the data from the db and updates the list in the chart
        /// </summary>
        var me = this;
        try {
            me._initList(true);

            // get data from db
            me.getData({ typeid: 14, bsaids: me.myStructure.allSelectedBsaids, startDate: me.myStructure.startDate, endDate: me.myStructure.endDate, isSingle: me.myStructure.isSingle, DataType: -1, LoggerId: me.specific.LoggerId }, function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }

                // fill list with data
                me.myStructure.current.data = result;

                me._generateList(true);

                return true;
            });
        } catch (e) {
            me.writeError('_updateCurrList', e);
            return false;
        }
    },

    _generateList: function (isCurr) {
        /// <summary>
        /// This function generates a list from the data
        /// </summary>
        var me = this;

        try {

            var list = me._initList(false);

            let obj = me.myStructure.current.data;

            if (obj === null) {
                list.html($("<br>"));
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }

            if (obj.rows === null) {
                list.html($("<br>"));
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }

            // fill corresponding list with items
            for (var i = 0; i < obj.rows.length; i++) {
                list.append(me._fillItems(i, isCurr));
            }

            me._formatTable();

            me.fnd(".placeholder").css("float", "right");

            me._updateListHeader();

            return true;
        } catch (e) { me.writeError('_generateList', e); return false; }
    },

    _fillItems: function (i, isCurr) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {
            let obj = null;
            var item = $("<div>", { "class": "vc-list-item" });

            var wCol0 = me.fnd("#divCol0").outerWidth();
            var wCol1 = me.fnd("#divCol2").outerWidth();
            var wCol2 = me.fnd("#divCol7").outerWidth();
            var wCol3 = me.fnd("#divCol8").outerWidth();
            var wCol4 = me.fnd("#divCol9").outerWidth();

            obj = me.myStructure.current.data;
            item.append($("<div>", { "class": "vc-list-col col0" }).outerWidth(wCol0).html($("<div>", { "class": "vc-list-col-element", "html": obj.rows[i].name + " [" + obj.rows[i].dims + "]" })));
            item.append($("<div>", { "class": "vc-list-col col1" }).outerWidth(wCol0).html($("<div>", { "class": "vc-list-col-element" + me._checkIfValidValue(obj.rows[i].zst), "html": me._fillZstValues(obj.rows[i].zst) })));
            item.append($("<div>", { "class": "vc-list-col col2" }).outerWidth(wCol1).html($("<div>", { "class": "vc-list-col-element txtLeft", "html": obj.rows[i].dims })));
            item.append($("<div>", { "class": "vc-list-col col3" }).outerWidth(wCol0).html($("<div>", { "class": "vc-list-col-element" + me._checkIfValidValue(obj.rows[i].zstEnd), "html": me._fillZstValues(obj.rows[i].zstEnd) })));
            item.append($("<div>", { "class": "vc-list-col col4" }).outerWidth(wCol1).html($("<div>", { "class": "vc-list-col-element txtLeft", "html": obj.rows[i].dims })));
            item.append($("<div>", { "class": "vc-list-col col5" }).outerWidth(wCol0).html($("<div>", { "class": "vc-list-col-element" + me._checkIfValidValue(obj.rows[i].zstDiff), "html": me._fillZstValues(obj.rows[i].zstDiff) })));
            item.append($("<div>", { "class": "vc-list-col col6" }).outerWidth(wCol1).html($("<div>", { "class": "vc-list-col-element txtLeft", "html": obj.rows[i].dims })));
            item.append($("<div>", { "class": "vc-list-col col7" }).outerWidth(wCol2).html($("<div>", { "class": "vc-list-col-element txtcenter", "html": obj.rows[i].zst_type })));
            item.append($("<div>", { "class": "vc-list-col col8" }).outerWidth(wCol3).html($("<div>", { "class": "vc-list-col-element txtcenter", "html": me._getStatusForItem(obj.rows[i].valid) })));
            item.append($("<div>", { "class": "vc-list-col col9" }).outerWidth(wCol4).html($("<div>", { "class": "vc-list-col-element txtLeft", "html": "" })));

            return item;

        } catch (e) { me.writeError('_fillItems', e); return false; }
    },

    _getStatusForItem: function (status) {
        /// <summary>
        /// checks if status is false for signal, then show error icon
        /// </summary>
        var me = this;
        try {
            if (!status)
                return "<i class='fa-regular fa-exclamation-triangle icon-color-error'></i>";
            else
                return "";

        } catch (e) { me.writeError('_getStatusForItem', e); return false; }
    },

    _checkIfValidValue: function (val) {
        /// <summary>
        /// checks if val is a valid value, otherwise placeholder class is added to the div
        /// </summary>
        var me = this;
        try {
            var addClass = "";
            if (val == null)
                addClass = " placeholder";
            else
                addClass = " value";

            return addClass;

        } catch (e) { me.writeError('_checkIfValidValue', e); return false; }
    },

    _fillZstValues: function (val) {
        /// <summary>
        /// checks if val is a valid value, otherwise placeholder shall be shown in the list
        /// </summary>
        var me = this;
        try {
            var value = val;

            if (val == null)
                val = "<br>";

            return val;

        } catch (e) { me.writeError('_fillZstValues', e); return false; }
    },

    _initList: function (showIcon) {
        /// <summary>
        /// initializes the list
        /// </summary>
        var me = this;
        try {

            var list = me.fnd(".lst-entries");

            if (showIcon)
                return list.html(me.getLoadingIcon()); // show loading icon
            else
                return list.html("");

        } catch (e) { me.writeError('_initList', e); return false; }
    },

    _formatTable: function () {
        /// <summary>
        /// formats the table/layout
        /// </summary>
        var me = this;
        try {

            me.fnd('.lst-entries .vc-list-item:even').addClass('alt');
            me.fnd('.lst-entries .vc-list-item .vc-list-col-element.value').formatDouble(2);

        } catch (e) { me.writeError('_formatTable', e); return false; }
    },

    _updateListHeader: function () {
        /// <summary>
        /// updates the list header with the selected date information
        /// </summary>
        var me = this;
        try {
            var zstStart = me.fnd(".lh.col1");
            var zstEnd = me.fnd(".lh.col3");

            zstStart.html("");            

            var prevDate = moment(me.myStructure.startDate, "DD.MM.YYYY").subtract(1, 'days').format("DD.MM.YYYY");
            zstStart.html(me.specific.resources.lastMeterReading + " (" + prevDate + ")");   

            // we check if the end date is in the future or valid
            var endDate = moment(me.myStructure.endDate, "DD.MM.YYYY");

            // if end date is in future, we set endDate to today's date
            if (endDate.isAfter(moment(), 'day')) { endDate = moment(); }

            // format endDate
            var finalEndDate = endDate.format("DD.MM.YYYY");

            if (!me.myStructure.isSingle) {                             
                zstEnd.html(me.specific.resources.lastMeterReading + " (" + finalEndDate + ")");
            }
            else {                
                zstEnd.html(me.specific.resources.lastMeterReading + " (" + me.myStructure.startDate + ")"); 
            }

        } catch (e) { me.writeError('_formatTable', e); return false; }
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd("#div-current").hide();
            }
            return true;
        } catch (e) {
            me.writeError('specificInfoHandling', e); return false;
        }
    }
});